import { createContext, useContext } from 'react';
import { Store } from './store';

export const StoreContext = createContext<Store>(null as unknown as Store);

export const useStore = () => useContext(StoreContext);